module.exports = __webpack_public_path__ + "media/images/icons/twotone/shopping-9afee994b9f9b5d95df5ac799aa48497.svg";